import { React, Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { BellIcon, CogIcon } from "@heroicons/react/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export default function Navbar() {
  const logOut = async () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };
  return (
    <>
      <div className="flex-1 px-2 flex justify-center lg:ml-6 lg:justify-end items-end">
        <div className="max-w-lg w-full lg:max-w-xs">
          <label htmlFor="search" className="sr-only">
            Search
          </label>
          <div className="relative text-gray-400 focus-within:text-gray-600">
            <input
              id="search"
              className="block w-full bg-white py-2 pl-10 pr-3 border  rounded-md leading-5 text-gray-900 placeholder-gray-500  sm:text-sm"
              placeholder="Search"
              type="search"
              name="search"
            />
          </div>
        </div>

        <div className="hidden lg:block lg:ml-4 pb-3">
          <div className="flex items-center">
            <button
              type="button"
              className=" flex-shrink-0 rounded-full p-1 text-gray-500"
            >
              <span className="sr-only">View notifications</span>
              <BellIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            {/* <button
              type="button"
              className=" flex-shrink-0 rounded-full p-1  text-gray-500 "
            >
              <span className="sr-only">View notifications</span>
              <CogIcon className="h-6 w-6" aria-hidden="true" />
            </button> */}
            {/* Profile dropdown */}
            <Menu as="div" className="ml-3 relative">
              <div>
                <Menu.Button className=" flex text-sm rounded-full text-gray-500">
                  <span className="sr-only">Open user menu</span>
                  <CogIcon className="h-6 w-6" aria-hidden="true" />
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  {/* <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                          >
                            Your Profile
                          </a>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                          >
                            Settings
                          </a>
                        )}
                      </Menu.Item> */}
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        type="button"
                        onClick={logOut}
                        className={classNames(
                          active ? "bg-gray-100" : "",
                          "block px-4 py-2 text-sm text-gray-700"
                        )}
                      >
                        Log out
                      </button>
                    )}
                  </Menu.Item>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </div>
      </div>
    </>
  );
}
